// GENERATED FILE - DO NOT MODIFY

export enum OrderingMethodDto {
    Alphabetical = "Alphabetical",
    Manual = "Manual",
}